export default class ForecastOpmService {
  constructor(server, FileService) {
    this.server = server;
    this.FileService = FileService;
  }

  import(file){
    return this.FileService.read(file).then(file => this.server('forecast-opm-import', {file: file}));
  }

  export(language) {
    window.open(this.server.getRequestUrl('forecast-opm-export', {
      language: language,
    }));
  }
}



// WEBPACK FOOTER //
// ./src/ForecastOpm/ForecastOpmService.js